// extracted by mini-css-extract-plugin
export default {"loading":"_Loading_loading__qcc-G"};